import React from 'react';
import MarketAccessCtaWithIcon from './MarketAccessCtaWithIcon';
import PropTypes from 'prop-types';

import './MarketAccessCtaWithIconsBlock.scss';

const MarketAccessCtaWithIconsBlock = ({ heading, items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="market-access-cta-with-icons-block">
      <div className="market-access-cta-with-icons-block__container">
        {heading && (
          <h2 className="market-access-cta-with-icons-block__heading">
            {heading}
          </h2>
        )}
        <ul className="market-access-cta-with-icons-block__list">
          {items.map((item, index) => {
            return (
              <li
                className="market-access-cta-with-icons-block__item"
                key={index}
              >
                <MarketAccessCtaWithIcon {...item} />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

MarketAccessCtaWithIconsBlock.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.exact(MarketAccessCtaWithIcon.propTypes))
    .isRequired,
};

export default MarketAccessCtaWithIconsBlock;
